<div class="container">
  <h3 class="page-title">Nova receita</h3>
  <mc-prescription-template-form [template]="template" (canceled)="goBack()" (saved)="saveTemplate()"></mc-prescription-template-form>
</div>
